import {
  timestamp
} from "./chunk-QBXWAUJA.mjs";

// src/utils/context/get-geo/get-geo.ts
var GEO_KEY = "__yvgtx";
var GEO_EXPIRES_TIME = 12 * 60 * 60 * 1e3;
async function getGeo() {
  const { unix } = timestamp();
  if (window.yvaDatastore) {
    const geoLocalStorage = localStorage.getItem(GEO_KEY);
    if (geoLocalStorage) {
      try {
        const parsedGeo = JSON.parse(geoLocalStorage);
        if (typeof parsedGeo === "object" && typeof parsedGeo.expires === "number" && parsedGeo.expires > unix && parsedGeo.city && parsedGeo.country && parsedGeo.region) {
          return {
            city: parsedGeo.city,
            country: parsedGeo.country,
            region: parsedGeo.region
          };
        }
      } catch (error) {
        if (window.yvaDatastore.config.debug) {
          console.error("Unable to parse stored geo.");
          console.dir(error, { depth: null });
        }
      }
    }
    if (window.yvaDatastore.config.providers?.geoProvider) {
      try {
        const geoData = await window.yvaDatastore.config.providers.geoProvider();
        if (geoData) {
          localStorage.setItem(GEO_KEY, JSON.stringify({ ...geoData, expires: unix + GEO_EXPIRES_TIME }));
          return geoData;
        }
      } catch (error) {
        if (window.yvaDatastore.config.debug) {
          console.error("Error fetching geo.");
          console.dir(error, { depth: null });
        }
      }
    }
    if (window.yvaDatastore.config.debug) {
      console.error(
        "Unable to determine geo context. Please ensure a valid `geoProvider` is supplied if geo data is required for your events."
      );
    }
    return { city: null, country: null, region: null };
  }
  return { city: null, country: null, region: null };
}

export {
  GEO_KEY,
  getGeo
};
